import React from 'react';

import { ProtectorType } from 'core/constants';
import { JSONSchemaType } from 'utils/api/modules/incidents/incidents.types';

import { EntityEnumsOptions, EntityValueType } from 'utils/api/modules/entities/entities.types';
import { EmptyValue } from 'components/SharedFormComponents/CustomFieldDisplayValue/styles';

import { Value } from 'components/SharedFormComponents/EditableTextInput/styles';
import EntityRowWrapper from 'components/Entities/EntityDetailsTab/RowWrapper';

type EntitySectionProps = {
  withDivider: boolean;
  item: {
    schema: JSONSchemaType;
    value: EntityValueType;
  };
  required?: boolean;
  helpText?: string | null;
  fieldKey?: string;
};

const EntityDropdownDisplayValue: React.FunctionComponent<EntitySectionProps> = ({
  withDivider,
  item,
  required,
  helpText,
  fieldKey,
}): React.ReactElement => {
  const value = item.value as EntityEnumsOptions[];
  const renderValue = (): JSX.Element => {
    if (!value || value.length === 0) {
      return <EmptyValue id="empty-value">-</EmptyValue>;
    }
    if (item.schema.protectorType === ProtectorType.MultiChoice) {
      return <Value>{value.map((v) => v.value).join(', ')}</Value>;
    }
    return <Value>{value[0].value}</Value>;
  };

  return (
    <EntityRowWrapper
      rowName={item.schema.name || 'N/A'}
      withDivider={withDivider}
      required={required}
      helpText={helpText}
      fieldKey={fieldKey}
    >
      {renderValue()}
    </EntityRowWrapper>
  );
};

export default EntityDropdownDisplayValue;
